module.exports = __webpack_public_path__ + "static/media/instagram.7adfcdd7.svg";